module.exports = __webpack_public_path__ + "static/media/plot_drawing_example.b21bf669.png";